import React, { useState, useEffect } from "react";
import MaterialExTable from "../../../../components/tables/MaterialExTable";
import { useOfficeHierarchyActivityTable } from "./../hooks/useOfficeHierarchyActivityTable";
const OfficeHierarchyActivyTable = ({ data }) => {
  const [, setLoading] = useState(true);
  useEffect(() => {
    let timer = setTimeout(() => setLoading(false), 5000);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  const { data: ohActTableData } = useOfficeHierarchyActivityTable(
    data?.officeHierarchyId
  );

  const materialColumns = [
    {
      title: "Activity",
      field: "message",
      cellStyle: {
        whiteSpace: "pre",
        width: "40%",
      },
    },
    { title: "Type", field: "type", width: "10%" },
    { title: "Hierarchy Name", field: "hierarchyName" },
    { title: "Hierarchy Code", field: "hierarchyCode" },
    { title: "District Code", field: "districtCode" },
    { title: "Region Code", field: "regionCode" },
    { title: "Area Code", field: "areaCode" },
    { title: "Territory Code", field: "territoryCode" },
    { title: "Date", field: "createdOn", width: "5%" },
  ];

  return (
    <div className="w-full p-2 bg-white">
      <div className="overflow-x-auto grid grid-row">
        <MaterialExTable
          data={ohActTableData}
          columns={materialColumns}
          options={{
            pageSize: 3,
            toolbar: false,
            showTitle: false,
            exportButton: false,

            search: true,
            headerStyle: {},
            rowStyle: {},
          }}
        />
      </div>
    </div>
  );
};

export default OfficeHierarchyActivyTable;
